import { useSelector } from 'react-redux';

import balanceSelectors from 'redux/balance/balanceSelectors';

import s from './balance.module.css';

// Для плашки баланс:
// 1) Если значение более 1000
// - убираем знаки после запятой
// 2) Если значение более 10 000
// - Цифры отображаем в формате 10.5К
// 3) Если значение меньше 1000
// - 1 знак после запятой
const formatValue = value => {
  if (!value) return 0;
  const numVal = Number(value);
  if (numVal >= 1000 && numVal < 10000) {
    return numVal.toFixed(0);
  }
  if (numVal >= 10000) {
    return `${(numVal / 1000).toFixed(1)}K`;
  }
  return numVal.toFixed(1);
};

function Balance() {
  const balance = useSelector(balanceSelectors.balance);

  return <p className={s.balance}>${formatValue(balance)}</p>;
}

export default Balance;
